import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=1ed2222b&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=ts"
export * from "./BlogPost.vue?vue&type=script&lang=ts"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=1ed2222b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2222b",
  null
  
)

export default component.exports